/**
 * Product page mobile carousels (≤ 767 px).
 * - brass_collection_bundle: 2 cards + peek third, native swipe scroll
 * - product_features: same native swipe pattern (Splide drag otherwise blocks scroll)
 */
(function () {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var CAROUSEL_PADDING = 20;
  var PEEK_DIVISOR = 2.22;

  var SECTIONS = [
    {
      selector: '[id*="brass_collection_bundle"]',
      trackSelector: '.x-block-products-list > .splide__track',
      carouselSelector: '.x-block-products-list',
      slideSelector: ':scope > .splide__slide, :scope > [class*="bundle-splide-slide-"]',
      scrollbarCss: function (id) {
        return '#' + id + ' .x-block-products-list > .splide__track::-webkit-scrollbar{display:none}';
      }
    },
    {
      selector: '[id*="product_features"]',
      trackSelector: '.text-column-with-image > .splide__track',
      carouselSelector: '.text-column-with-image',
      slideSelector: ':scope > .splide__slide, :scope > [class*="preload-slide--"]',
      scrollbarCss: function (id) {
        return '#' + id + ' .text-column-with-image > .splide__track::-webkit-scrollbar{display:none}';
      }
    }
  ];

  var CAROUSEL_PROPS = [
    'overflow-x', 'overflow-y', 'scroll-snap-type', '-webkit-overflow-scrolling',
    'scrollbar-width', 'width', 'display', 'flex-wrap', 'gap', 'transform',
    'height', 'padding', 'margin', 'max-width', 'min-width', 'flex-shrink',
    'flex', 'margin-right', 'box-sizing', 'overflow', 'scroll-snap-align',
    'scroll-snap-stop', 'touch-action'
  ];

  function imp(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  function resetCardImageSplides(section) {
    section.querySelectorAll('.card-product .splide__track, .card-product .splide__list, .card-product .splide__slide').forEach(function (el) {
      CAROUSEL_PROPS.forEach(function (prop) {
        el.style.removeProperty(prop);
      });
    });
  }

  function getCarouselTracks(section, config) {
    return Array.from(section.querySelectorAll(config.trackSelector)).filter(function (track) {
      return !track.closest('.card-product');
    });
  }

  function disableSplideDrag(carousel) {
    if (!carousel || carousel._splideDragDisabled) return;
    var splide = carousel.splide;
    if (!splide) return;

    try {
      splide.options.drag = false;
      if (splide.Components && splide.Components.Drag) {
        splide.Components.Drag.disable(true);
      }
    } catch (e) { /* Splide API may vary */ }

    carousel._splideDragDisabled = true;
  }

  function wireGestureAxisLock(track) {
    if (track._gestureAxisWired) return;
    track._gestureAxisWired = true;

    var startX = 0;
    var startY = 0;
    var axis = null;
    var THRESHOLD = 10;

    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      axis = null;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (!axis && (Math.abs(dx) > THRESHOLD || Math.abs(dy) > THRESHOLD)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      if (axis === 'y') {
        track.style.setProperty('overflow-x', 'hidden', 'important');
      }
    }, { passive: true });

    function resetAxis() {
      axis = null;
      imp(track, 'overflow-x', 'auto');
    }

    track.addEventListener('touchend', resetAxis, { passive: true });
    track.addEventListener('touchcancel', resetAxis, { passive: true });
  }

  function getSlideWidth(trackW) {
    var gap = 12;
    var viewportW = document.documentElement.clientWidth || window.innerWidth;
    var basis = trackW > 0 ? trackW : Math.max(0, viewportW - CAROUSEL_PADDING);
    return Math.max(120, Math.floor((basis - gap) / PEEK_DIVISOR));
  }

  function setupCarousel(section, config) {
    if (!section || !config) return false;

    resetCardImageSplides(section);

    var tracks = getCarouselTracks(section, config);
    if (!tracks.length) return false;

    var anyReady = false;

    tracks.forEach(function (track) {
      var list = track.querySelector('.splide__list');
      if (!list) return;

      var trackW = track.clientWidth;
      if (trackW <= 0) return;

      var gap = 12;
      var slideW = getSlideWidth(trackW);
      var slides = Array.from(list.querySelectorAll(config.slideSelector));
      if (!slides.length) return;

      var carousel = track.closest(config.carouselSelector);
      disableSplideDrag(carousel);

      imp(track, 'overflow-x', 'auto');
      imp(track, 'overflow-y', 'hidden');
      imp(track, 'scroll-snap-type', 'x mandatory');
      imp(track, '-webkit-overflow-scrolling', 'touch');
      imp(track, 'scrollbar-width', 'none');
      /* manipulation = pan-x + pan-y; pan-x alone traps the page and blocks vertical scroll */
      imp(track, 'touch-action', 'manipulation');
      imp(track, 'width', '100%');

      if (!track._scrollbarStyleAdded) {
        var host = section.id ? section : track.closest('[id]');
        if (host && host.id) {
          var st = document.createElement('style');
          st.textContent = config.scrollbarCss(host.id);
          document.head.appendChild(st);
          track._scrollbarStyleAdded = true;
        }
      }

      imp(list, 'display', 'flex');
      imp(list, 'flex-wrap', 'nowrap');
      imp(list, 'gap', gap + 'px');
      imp(list, 'transform', 'none');
      imp(list, 'width', 'auto');
      imp(list, 'height', 'auto');
      imp(list, 'padding', '0');
      imp(list, 'margin', '0');

      slides.forEach(function (slide) {
        imp(slide, 'width', slideW + 'px');
        imp(slide, 'max-width', slideW + 'px');
        imp(slide, 'min-width', slideW + 'px');
        imp(slide, 'flex', '0 0 ' + slideW + 'px');
        imp(slide, 'flex-shrink', '0');
        imp(slide, 'margin-right', '0');
        imp(slide, 'box-sizing', 'border-box');
        imp(slide, 'overflow', 'hidden');
        imp(slide, 'scroll-snap-align', 'start');
        slide.style.removeProperty('scroll-snap-stop');
      });

      wireGestureAxisLock(track);
      track._mobileCarouselReady = true;
      anyReady = true;
    });

    return anyReady;
  }

  function trySetup(section, config, attemptsLeft) {
    if (!section) return;
    var ok = setupCarousel(section, config);
    if (!ok && attemptsLeft > 0) {
      var delay = attemptsLeft === 3 ? 300 : attemptsLeft === 2 ? 800 : 1600;
      setTimeout(function () { trySetup(section, config, attemptsLeft - 1); }, delay);
    }
  }

  function resetSectionCarousels(section, config) {
    if (!section) return;
    getCarouselTracks(section, config).forEach(function (track) {
      track._mobileCarouselReady = false;
    });
    section.querySelectorAll(config.carouselSelector).forEach(function (carousel) {
      carousel._splideDragDisabled = false;
    });
    setupCarousel(section, config);
  }

  function initSection(config) {
    var section = document.querySelector(config.selector);
    if (!section) return;

    trySetup(section, config, 3);

    var sectionId = section.id.replace('shopify-section-', '');
    document.addEventListener('eurus:' + sectionId + ':splide-ready', function () {
      resetSectionCarousels(section, config);
    });

    var debounceTimer;
    var observer = new MutationObserver(function () {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { resetSectionCarousels(section, config); }, 150);
    });
    observer.observe(section, { childList: true, subtree: true });

    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      setupCarousel(section, config);
    }, { passive: true });
  }

  function init() {
    SECTIONS.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
